/**
 * @file: 体温检测
 * @author: wence
 */
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import ProductTitle from '../../components/ProductTitle';
import Dplayer from 'dplayer-cus-lite';
import './temperature.less';
export default class AiTemperature extends PureComponent {
    static propTypes = {
        pagesDatabyid: PropTypes.any
    }
    constructor(props) {
        super(props);

        if (this.isPC()) {
            location.href = '/page/ai/temperature';
        }
    }

    componentDidMount() {
        const dp = new Dplayer({
            container: document.getElementById('saas-t-video'),
            autoplay: false,
            theme: '#b7daff',
            loop: 0,
            preload: 'auto',
            video: {
                url: '//secapi.cdn.bcebos.com/ai/video.mp4',
                type: 'auto'
            },
            mutex: 1,
            iconsColor: 'red'
        });

        dp.on('ended', function () {
            dp.seek(0);
        });
    }

    render() {
        this.shareWX({
            title: '百度安全-有AI更安全',
            content: '百度AI体温检测解决方案自2020年1月28日在北京清河站试运行以来，已有超过上万人通过检测。同时，我们已将这一解决方案对外开放，以AI安全之力助力全国疫情防控战役。'
        });
        const advanageList = [
            {
                title: '实时高效',
                des: <div>
                    <p>在单人通道顺序通行条件下，可在1分钟内实现对逾200人同时通过的体温实时检测，实现人群无停留过检，缓解人员堵塞。</p>
                    <p>*参考数据，受人群密度及行进速度影响。</p>
                </div>
            },
            {
                title: '精准可靠',
                des: '实现了体温检测与人脸识别的技术同步及佩戴口罩时的识别问题，可准确定位、快速锁定体温异常人员并实时自动告警，方便工作人员进行二次复检。'
            },
            {
                title: '非接触无感知',
                des: '借助全自动化的体温检测，被检人员仅需做弱配合，大幅减少相互的近距离接触，降低潜在的安全隐患。'
            },
            {
                title: '快速部署降低成本',
                des: '实现检测结果的实时可视化，并可在通道、重要区域快速部署，有效降低成本，缓解疫情防控期间紧张的人力资源调配。'
            }
        ];
        const reportList = [
            {
                title: '央视新闻',
                des: `“目前，在单人通道顺序通行条件下，百度AI多人体温快速检测解决方案可在1分钟内实现对逾200人同时通过的体温实时检测（实际数据受人群密度及行进速度影响），
                    使旅客可无停留过检，缓解检测造成的出入口人员堵塞压力，并最终实现旅客快速通行和“一个不落”地接受到体温检测的双重目标。”`,
                url: `http://rmbjb.jyrmb.com/INF_List_TV.asp?SortStr=INF&Sucaid=2&ID=CT2020020222102200001&SID=3237
                    &Daystr=2020-02-02&Title=&CGUID=D73C3BCB-2070-4352-B0C5-525F8648AD17&charset=gb2312`
            },
            {
                title: '北京日报',
                des: ` “目前市场上的大客流体温监测设备，主要是以硬件为主导的高温红外设备检测仪器，但造价高、严重缺货。为应对返京大客流到来的需要，
                    百度公司对其软件系统进行优化，解决高铁站半开放环境气温低、出站人员戴口罩戴帽子人脸信息缺失等难点，研发调试出AI大客流体温检测解决方案。”`,
                url: `https://ie.bjd.com.cn/5b165687a010550e5ddc0e6a/contentApp
                    /5b1a1310e4b03aa54d764015/AP5e363eaae4b0768ce1976e67
                    ?isshare=1&app=ae1971f4eac243f3`
            },
            {
                title: '北京电视台',
                des: `“除了在筛选效率方面的提升，该解决方案的部署也十分简便。比如，在通道或重要区域放置固定点位摄像机，在无需群众配合或弱配合的情况下，摄像机完 3-5 人/批次的面部温度快速检测系统。
                    目前，该系统能够测量的温差在 0.05 摄氏度之内。”`,
                url: 'https://haokan.baidu.com/v?vid=8760943309900751167&pd=bjh&fr=bjhauthor&type=video'
            }
        ];
        return (
            <div className="product">
                <div className="pro-banner-box">
                    <div className="proBanner saas-t-banner">
                        <a className="saas-t-btn" href="/m/apply">合作咨询</a>
                    </div>
                </div>
                <p className="saas-t-des" style={{paddingTop: '1rem'}}>
                    百度AI体温检测解决方案自2020年1月28日在北京清河站试运行以来，已有超过上<span className="saas-t-tag">万人</span>通过检测。
                    同时，我们已将这一解决方案对外开放，<span className="saas-t-tag">以AI安全之力助力全国疫情防控战役</span>。
                </p>
                <p className="saas-t-des">
                    当前，全国对新型冠状病毒疫情的防控已进入关键期，在车站等人流量巨大的公共场所，如何安全、快速、高效地实现对来往人群的体温检测逐渐成为防控工作的重要一环。
                </p>
                <p className="saas-t-des">
                    针对现有体温检测系统所存在的局限性，百度AI多人体温快速检测解决方案落地应用。
                    基于AI图像识别技术和红外热成像技术，以非接触、无感知的方式，可靠、高效地解决了在公共场所人员高度聚集、高流动性情况下的体温实时初筛检测问题。
                </p>

                <div className="saas-t-video">
                    <div id="saas-t-video">
                    </div>
                </div>

                <div className="saas-t-header">
                    <ProductTitle title="核心优势" />
                </div>

                <div className="saas-t-advantage">
                    {advanageList.map((item, index) => {
                        return (
                            <div
                                className={`saas-t-advantage-item bg${index + 1}`}
                                key={index}>
                                <div className="title">{item.title}</div>
                                <div className="des">{item.des}</div>
                            </div>
                        );
                    })}
                </div>

                <div className="saas-t-report-container">
                    <div className="saas-t-header">
                        <ProductTitle title="媒体报道" />
                    </div>

                    <div className="saas-t-report">
                        {reportList.map((item, index) => {
                            return (
                                <a
                                    href={item.url}
                                    target="_blank"
                                    className="saas-t-report-item"
                                    key={index}>
                                    <div className="title">{item.title}</div>
                                    <div className="des">{item.des}</div>
                                </a>
                            );
                        })}
                    </div>
                </div>
                <div className="saas-t-footer-container">
                    <div className="saas-t-footer">
                        更多教育、工业、场馆等场景AI解决方案
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            className="saas-t-btn"
                            href="https://anquan.baidu.com/page/47">了解详情</a>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/product/temperature.js